var _desc, _g, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMasinaMica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon ma\u0219in\u0103 mic\u0103") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Icon vectorial pentru autoturism, \xEEn stilul setului de referin\u021B\u0103.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5D2973"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 91,
    width: 46,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 112,
    width: 38,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 133,
    width: 53,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 154,
    width: 20,
    height: 9,
    rx: 4.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D313C",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "     M63 145V119.5C63 108.7 70.1 99.2 80.4 96L92.5 92.2L108.2 71.4C113.9 63.8 122.9 59.3 132.4 59.3H159.8C169.3 59.3 178.5 62.9 185.4 69.5L208.1 91.1L222.1 94.5C236.8 98.1 247 111.3 247 126.4V143C247 152.4 239.4 160 230 160H76C68.8 160 63 153.3 63 145Z     M110 77.5C114.2 71.3 120.5 68 128 68H144V96H96L110 77.5Z     M153 68H160.5C167.3 68 173.2 70.3 178.2 75L198 94H153V68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D313C",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "     M126 160A25 25 0 1 1 76 160A25 25 0 1 1 126 160Z     M109 160A8 8 0 1 1 93 160A8 8 0 1 1 109 160Z     M229 160A25 25 0 1 1 179 160A25 25 0 1 1 229 160Z     M212 160A8 8 0 1 1 196 160A8 8 0 1 1 212 160Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 112,
    width: 10,
    height: 20,
    rx: 4,
    fill: "#5D2973"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMasinaMica);
export default __webpack_public_path__ + "static/media/IconMasinaMica.5cc1cee954294a536c6ab951b46c2373.svg";
export { ForwardRef as ReactComponent };